import { ITooltipParams } from "ag-grid-community";

export const MultiLineTooltipValueGetter = (params: ITooltipParams) => {
  // null

  let colDef = params.colDef;
  let value: string = "";

  if (params.valueFormatted != null) {
    value = params.valueFormatted;
  } else if (params.value != null) {
    value = params.value;
  }

  value = value.split("; ").join(" \u000A");

  return value;
};
